import { BadgeContainer } from "@progress/kendo-react-indicators";
import { Tooltip } from "@progress/kendo-react-tooltip";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useThemeSwitcher } from "react-css-theme-switcher";
import { useDispatch, useSelector } from "react-redux";
import { matchPath, useHistory, useLocation } from "react-router";
import { setActiveOrganizationSidebar } from "../../../../actions/admin";
import { updateCurrUser } from "../../../../actions/auth";
import { setUpdateLayoutDesc, updatesIsCollabCentralOpened } from "../../../../actions/common";
import { setContentManagerDataDetails, setSelectedContentItem } from "../../../../actions/contentManager";
import { showTaskSidebarOnTop } from "../../../../actions/latestSidebar";
import { resetLinkTaskForNewTask } from "../../../../actions/linkedTasks";
import { setNotificationCount, setPendingApprovalsCount, setShowNotifications } from "../../../../actions/notifications";
import { resetPlanMyday } from "../../../../actions/planMyDay";
import { setIsApprovalFilterSelected, setLastFilterId } from "../../../../actions/projects";
import { resetSidebarReducer, setShowTaskSidebar } from "../../../../actions/taskSidebar";
import { setUserFav } from "../../../../actions/userPosition";
import { FEATURE_DISPLAY_NAMES } from "../../../../components/Admin/ManageOrganization/OrganizationFeatures/organizationFeatures.constants";
import { useActionRegistry } from "../../../../components/App/ActionRegistryContext";
import MainHeaderSkeleton from "../../../../components/App/SuspenseFallback/MainHeaderSkeleton";
import BackForwardNavigation from "../../../../components/BackForwardNavigation/BackForwardNavigation";
import { BreadcrumbComponent } from "../../../../components/ContentManagementSystem/ContentManager/Breadcrumb";
import { searchTreeItem } from "../../../../components/ContentManagementSystem/helper";
import FormFiller from "../../../../components/Forms/FormFiller/FormFiller";
import { useFormSubmission } from "../../../../components/Forms/forms.hooks";
import Loader from "../../../../components/Loader/Loader";
import Notes from "../../../../components/Notes/Notes";
import Notifications from "../../../../components/Notifications/Notifications";
import { getNotificationsCount } from "../../../../components/Notifications/notifications.service";
import OverallSearch from "../../../../components/OverallSearch/OverallSearch";
import ProjectDetailsPopup from "../../../../components/Projects/ProjectDetailsPopup";
import QueueDetailsPopup from "../../../../components/Queues/QueueDetailsPopup";
import { getAttachmentObject } from "../../../../components/TaskSidebar/TaskSidebarContent/Attachments/attachments.helper";
import { ReminderContextProvider } from "../../../../components/Tasks/Reminders/ReminderContextProvider";
import { handleCloseSidebar } from "../../../../components/Tasks/tasks.common";
import { getDefaultTaskValues, pendingApprovalsCount } from "../../../../components/Tasks/tasks.service";
import { icon, label, notifyIcon, number, quote, route, tooltip } from "../../../../config";
import { generateYdocRoomId, getQueryParams, truncateName } from "../../../../helper/common";
import { useCombinationKeys, usePageHeading } from "../../../../helper/commonHooks";
import { splitString } from "../../../../utils";
import { trackClickedAddTask } from "../../../../utils/analytics";
import { appendString, dateConvert, getNotification } from "../../../../utils/common";
import { getAllProjects, isNewStreamAdded } from "../../../services/projects.service";
import { getUserView, updateUserFavorite } from "../../../services/user.service";
import { getWorkflowFormById } from "../../../services/workflow.services";
import CollabCentralLayout from "../../CollabCentralLayout";
import UserDropdown from "../UserDropdown/UserDropdown";
import AddReminderPopup from "./AddReminderPopup";
import AutomationBreadcrumb from "./AutomationBreadcrumb";
import HeaderSplitButton from "./HeaderSplitButton";
import MultiUploadDropdown from "./MultiUploadDropdown";
import OrganisationPopUp from "./OrganisationPopUp";
import PlanMyDay from "./PlanMyDay";
import "./header.scss";
import { routeWithBreadcrumbs } from "./organisationPopUpConstants";
import { FORM_TABS } from "../../../../components/Forms/FormsConstant";
const MainHeader = () => {
  const profileRef = useRef();
  const buttonRef = useRef();
  const overallSearchRef = useRef();
  const layoutDescriptionRef = useRef();
  const projectClickRef = useRef();
  const queueClickRef = useRef();
  const [openProfile, setOpenProfile] = useState(false);
  const [pageParamState, setPageParamState] = useState({});
  const [currentRoute, setCurrentRoute] = useState({});
  const [projectNameState, setProjectNameState] = useState("");
  const [project, setProject] = useState("");
  const [queueName, setQueueName] = useState("");
  const [queueIdparam, setQueueId] = useState(null);
  const [showDescription, setShowDescription] = useState(false);
  const [showOrganization, setShowOragnization] = useState(false);
  const [showReminderPopup, setShowReminderPopup] = useState(false);
  const [showProjectPopup, setShowProjectPopup] = useState(false);
  const [showQueuePopup, setShowQueuePopup] = useState(false);

  // Form Filler states - moved from CollabCentralLayout to persist when layout unmounts
  const [showFormFiller, setShowFormFiller] = useState(false);
  const [formData, setFormData] = useState(null);
  const [loadingForm, setLoadingForm] = useState(false);

  // Use the form submission hook
  const { submitFormWithFiles } = useFormSubmission();

  const location = useLocation();
  const newDate = new Date();
  const auth = useSelector((state) => state.auth);
  const history = useHistory();
  const { mode, operationalTeamName } = auth.user;
  const { deferHeaderSidebarLoading, task } = useSelector((state) => state.taskSidebar);

  const notifications = useSelector((state) => state.notifications);
  const { reminderCount, approvalCount, showApprovalIcon, pendingApprovalsCount: pendingApprovalsFromRedux } = notifications;
  const allProjectsList = useSelector((state) => state.tasks.defaultDetails.allProjectsList);
  const allProjects = useSelector((state) => state.allProjects.data);
  const loading = useSelector((state) => state.loader.loading);
  const isCollabCentralOpened = useSelector((state) => state.common.isCollabCentralOpened);
  const { automations, selectedAutomation } = useSelector((state) => state.automation);
  const dispatch = useDispatch();
  const ctrlD = useCombinationKeys("d");
  const { currentTheme } = useThemeSwitcher();
  const user = auth.user;
  const createTask = getQueryParams("createTask", location.search);
  const { id, companyPictures } = useSelector((state) => state.auth.user);
  const { selectedContentManagerItem, contentManagerData, fileMetaData } = useSelector((state) => state.contentManager);
  const path = location.pathname;
  const isTaskSidebarRoute = path === route.PRIVATE_ROUTE.TASK_SIDEBAR.PATH;
  const isBreadcrumbRoute = routeWithBreadcrumbs.some((keyword) => path.includes(keyword));
  const isTaskRoute = path.includes("tasks");
  const isCmsRoute = path.includes(label.LIBRARY_ROUTE) || path.includes("cms");
  const isEmailRoute = path.includes(route.PRIVATE_ROUTE.EMAILS.PATH);
  let projectId = isCmsRoute
    ? fileMetaData?.item?.projectId?.toString() ?? pageParamState?.projectId
    : pageParamState?.projectId;
  let workflowId = pageParamState?.workflowId;
  const { teamLeftSelectedTab } = useSelector((state) => state.projectSidebar);
  const addButtonRef = useRef();
  const { userFavViews, views } = useSelector((state) => state.userViews);
  const { organisationPopUpShow } = useSelector((state) => state.auth.user);
  const { lastSelectedBoard } = useSelector((state) => state.auth.user);
  const { teamSavedFilters, lastFilterId } = useSelector((state) => state.teamFilter);
  const { isPlanMyDayActive } = useSelector((state) => state.planMyDay);
  const isDirectory = useMemo(() => path === `${route.PRIVATE_ROUTE.USER_DIRECTORY.PATH}`, [path]);
  const { registerAction } = useActionRegistry();
  const commonPagePath = useMemo(() => {
    return path === route.PRIVATE_ROUTE.PROJECT.PATH ;
  }, [path]);
  const isReminderRoute = path.startsWith(route.PRIVATE_ROUTE.REMINDER.PATH);
  const isCommentRoute = path.startsWith(route.PRIVATE_ROUTE.COMMENT.PATH);
  const isBoardOnlyBreadcrumbRoute = isReminderRoute || isCommentRoute;
  const { header } = usePageHeading();

  const queueIdParam = useMemo(() => {
    return pageParamState?.queueId || allProjectsList?.find((i) => i.ProjectId == projectId)?.QueueId;
  }, [pageParamState?.queueId, allProjectsList, projectId]);

  /** Returns the favorite item from userFavViews that matches current route and project/queue */
  const favoriteItem = useMemo(() => {
    const getFavoriteLabel = () => {
      if (isCmsRoute) return label.LIBRARY;
      if (isEmailRoute) return route.PRIVATE_ROUTE.EMAILS.ENTITY_NAME;
      return lastSelectedBoard;
    };

    return userFavViews.find((fav) => {
      const matchesProject = projectId ? fav.ProjectId == projectId : fav.QueueId == pageParamState.queueId;
      const matchesLabel = fav.Label === getFavoriteLabel();
      return matchesProject && matchesLabel;
    });
  }, [userFavViews, projectId, pageParamState.queueId, lastSelectedBoard, isCmsRoute, isEmailRoute]);

  const isFavorite = useMemo(() => !!favoriteItem, [favoriteItem]);
  const approvalFilter = useMemo(() => {
    return teamSavedFilters?.find((item) => item.label === label.PENDING_APPROVALS)?.value === lastFilterId;
  }, [teamSavedFilters, lastFilterId]);
  const { queueSavedFilters } = useSelector((state) => state.queueTaskPage);
  const queueuLastFilterId = useSelector((state) => state.queueTaskPage.lastFilterId);
  const queueFilter = useMemo(() => {
    return queueSavedFilters?.find((item) => item.label === label.PENDING_APPROVALS)?.value === queueuLastFilterId;
  }, [queueSavedFilters, queueuLastFilterId]);

  const showPopup = useMemo(() => {
    return pageParamState?.queueId || pageParamState?.projectId || queueIdParam;
  }, [pageParamState?.queueId, pageParamState?.projectId, queueIdParam]);

  /**
   * Handle clicking outside the project popup to close it
   */
  useEffect(() => {
    if (!showProjectPopup) return;
    const handleClickOutside = (event) => {
      if (
        event.target.closest(".project-details-popup-content") ||
        event.target.closest(".notification-popup-content") ||
        event.target.closest(".edit-project-sidebar") ||
        event.target.closest(".k-animation-container") ||
        event.target.closest(".k-popup")
      ) {
        return;
      }
      setShowProjectPopup(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showProjectPopup, showQueuePopup]);

  /**
   * Handle clicking outside the queue popup to close it
   */
  useEffect(() => {
    if (!showQueuePopup) return;
    const handleClickOutside = (event) => {
      if (
        event.target.closest(".queue-details-popup-content") ||
        event.target.closest(".create-project-popup") ||
        event.target.closest(".move-project-popup") ||
        event.target.closest(".add-workspace-owner-popup") ||
        event.target.closest(".more-menu-popup-queue") ||
        event.target.closest(".move-project-dropdown") ||
        event.target.closest(".workspace-owners-dropdown")
      ) {
        return;
      }
      setShowQueuePopup(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showQueuePopup, showProjectPopup]);

  useEffect(() => {
    registerAction("addReminder", handleAddReminder);
    registerAction("addTask", handleAddTask);
  }, []);

  /* Used to get notification count for the main header */
  useEffect(() => {
    if (deferHeaderSidebarLoading || (isTaskSidebarRoute && !task?.taskId) ) {
      return;
    }
    if(isTaskSidebarRoute) { 
      dispatch(getNotificationsCount(user.id));
      setCurrentRouteFunction();
    }
  }, [deferHeaderSidebarLoading, isTaskSidebarRoute, task?.taskId]);

  useEffect(() => {
    if(!isTaskSidebarRoute) { 
      dispatch(getNotificationsCount(user.id));
      setCurrentRouteFunction();
    }
  }, []);

  useEffect(() => {
    if (isTaskSidebarRoute && (deferHeaderSidebarLoading || !task?.taskId)) return;
    if (pendingApprovalsFromRedux > number.ZERO || showApprovalIcon) return;

    (async () => {
      const response = await pendingApprovalsCount();
      dispatch(setPendingApprovalsCount(response?.pendingApprovalsCount || number.ZERO));
    })();
  }, [deferHeaderSidebarLoading, isTaskSidebarRoute, task?.taskId, pendingApprovalsFromRedux, showApprovalIcon]);

  useEffect(() => {
    setShowOragnization(organisationPopUpShow);
  }, [organisationPopUpShow]);

  /**
   * to call api on load - only if projects list is empty
   */
  useEffect(() => {
    if (deferHeaderSidebarLoading || (isTaskSidebarRoute && !task?.taskId) ) {
      return;
    }
  }, [pageParamState.queueId, projectId, deferHeaderSidebarLoading, isTaskSidebarRoute, task?.taskId]);

  useEffect(() => {
    if (allProjectsList?.length === number.ZERO && !isTaskSidebarRoute) dispatch(getDefaultTaskValues(user.companyId, user.id));
  }, []);

  useEffect(() => {
    if (allProjects?.length === number.ZERO && !isTaskSidebarRoute) dispatch(getAllProjects());
  }, []);

  /**
   * return the label of canvas on basis of the level
   * @author Sarthak Arora
   */
  const getTeamConnectLabel = () => {
    switch (true) {
      case !!projectId:
        return label.TEAM_CANVAS;
      case !!pageParamState.queueId:
        return label.WORKSPACE_CANVAS;
      case !projectId:
        return label.MY_CANVAS;
      default:
        return lastSelectedBoard;
    }
  };

  /**
   * handles the open/close of collab central layout
   * @author Bhavana
   */
  useEffect(() => {
    if (!isCollabCentralOpened) {
      setShowDescription(false);
      dispatch(updatesIsCollabCentralOpened(false));
    } else {
      setShowDescription(true);
      dispatch(updatesIsCollabCentralOpened(true));
    }
  }, [isCollabCentralOpened]);

  useEffect(() => {
    ctrlD && handleAddTaskButton();
  }, [ctrlD]);

  /**
   * handles theme mode of drutas
   * @author Sejal
   */
  useEffect(() => {
    if (currentTheme == "light") {
      import("../../../../assets/themes/light-theme-variables.scss");
      import("../../../../assets/themes/light-theme.scss");
    } else if (currentTheme == "dark") {
      import("../../../../assets/themes/dark-theme-variables.scss");
      import("../../../../assets/themes/dark-theme.scss");
    }
  }, [currentTheme]);

  /**
   * Clear project and queue names on context change to prevent stale breadcrumbs
   * @author Muskan Thakur
   */
  useEffect(() => {
    setProjectNameState("");
    setQueueName("");
  }, [fileMetaData?.item?.projectId, pageParamState?.projectId]);

  useEffect(() => {
    const onCmsRoute = location.pathname.includes(label.LIBRARY_ROUTE) || location.pathname.includes("cms");
    const resolvedProjectId = onCmsRoute
      ? fileMetaData?.item?.projectId ?? pageParamState?.projectId
      : pageParamState?.projectId;
    setQueueName(allProjects?.find((i) => i.ProjectId == resolvedProjectId)?.QueueName);
    if (resolvedProjectId == auth?.user?.myProjectId) return;
    else {
      let projectNametemp = allProjects?.find((i) => i.ProjectId == resolvedProjectId)?.ProjectName;
      if (projectNametemp) setProjectNameState(projectNametemp);
      else setProjectNameState(allProjectsList?.find((i) => i.ProjectId == resolvedProjectId)?.ProjectName);
    }
  }, [pageParamState?.projectId, allProjects, fileMetaData?.item?.projectId, allProjectsList, location.pathname]);

  useEffect(() => {
    if (pageParamState.queueId) setQueueName(pageParamState?.queueName);
  }, [pageParamState.queueId, pageParamState.projectId]);

  useEffect(() => {
    const personalBoard = auth.user.Name + label.S_BOARD;
    let currentProject = projectNameState ? projectNameState : queueName ? queueName : personalBoard;
    setProject(currentProject);
    let queueNametemp = allProjects?.find((i) => i.ProjectId == projectId)?.QueueName;
    if(queueNametemp)
    setQueueName(queueNametemp);
    else setQueueName(allProjectsList?.find((i) => i.ProjectId == projectId)?.QueueName);
    setQueueId(allProjects?.find((i) => i.ProjectId == projectId)?.QueueId);
  }, [projectNameState,  auth.user]);

  /***
   * Fetches if we have any unread stream
   * @author Sejal
   */
  useEffect(() => {
    (async () => {
      const unreadStreamId = await isNewStreamAdded(auth.user.id, null);
      dispatch(updateCurrUser({ isStreamUpdate: unreadStreamId?.StreamAdded }));
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (location) {
        setCurrentRouteFunction();
        dispatch(setUpdateLayoutDesc(false));
      }
    })();
  }, [location]);
  /**
   * handling the open/close of dropdown menu
   * @returns {boolean to open/close dropdown}
   */
  const handleDropdownClick = (e) => {
    setOpenProfile(!openProfile);
  };

  /**
   * Sets router object from routes.js based on current route for header and icon
   */
  const setCurrentRouteFunction = () => {
    let pathname = location.pathname;
    setPageParams(pathname);
    let currentRoute = Object.values({ ...route.PRIVATE_ROUTE, ...route.ADMIN_ROUTE, ...route.SUPER_ADMIN_ROUTE }).find((r) => {
      return pathname.includes("superAdmin") ? r.PATH.includes(pathname) : r.PATH.includes(splitString(pathname, "/")[1]);
    });
    setCurrentRoute(currentRoute);
  };

  /**
   *
   * Sets state variable as page params task page
   * @param {String} pathname
   * @author Himanshi Chawla
   */
  const setPageParams = (pathname) => {
    if (matchPath(pathname, { path: route.PRIVATE_ROUTE.TASKS.ROUTER_PATH })) {
      const { params } = matchPath(pathname, { path: route.PRIVATE_ROUTE.TASKS.ROUTER_PATH });
      setPageParamState(params);
    } else if (matchPath(pathname, { path: route.PRIVATE_ROUTE.QUEUE_TASKS.ROUTER_PATH })) {
      const { params } = matchPath(pathname, { path: route.PRIVATE_ROUTE.QUEUE_TASKS.ROUTER_PATH });
      setPageParamState(params);
    } else if (matchPath(pathname, { path: route.PRIVATE_ROUTE.Y_DOC.ROUTER_PATH })) {
      const { params } = matchPath(pathname, { path: route.PRIVATE_ROUTE.Y_DOC.ROUTER_PATH });
      setPageParamState(params);
    } else if (matchPath(pathname, { path: route.PRIVATE_ROUTE.CMS.ROUTER_PATH })) {
      const { params } = matchPath(pathname, { path: route.PRIVATE_ROUTE.CMS.ROUTER_PATH });
      setPageParamState(params);
    } else if (matchPath(pathname, { path: route.PRIVATE_ROUTE.WORKFLOW.ROUTER_PATH })) {
      const { params } = matchPath(pathname, { path: route.PRIVATE_ROUTE.WORKFLOW.ROUTER_PATH });
      setPageParamState(params);
    } else if (matchPath(pathname, { path: route.PRIVATE_ROUTE.EMAILS.ROUTER_PATH })) {
      const { params } = matchPath(pathname, { path: route.PRIVATE_ROUTE.EMAILS.ROUTER_PATH });
      setPageParamState(params);
    } else if (matchPath(pathname, { path: route.PRIVATE_ROUTE.USER_PROFILE_SETTING.ROUTER_PATH })) {
      const { params } = matchPath(pathname, { path: route.PRIVATE_ROUTE.USER_PROFILE_SETTING.ROUTER_PATH });
      setPageParamState(params);
    } else if (matchPath(pathname, { path: route.PRIVATE_ROUTE.TEAM_SETTING.ROUTER_PATH })) {
      const { params } = matchPath(pathname, { path: route.PRIVATE_ROUTE.TEAM_SETTING.ROUTER_PATH });
      setPageParamState(params);
    } else if (matchPath(pathname, { path: route.PRIVATE_ROUTE.AUTOMATION_DETAIL.ROUTER_PATH })) {
      const { params } = matchPath(pathname, { path: route.PRIVATE_ROUTE.AUTOMATION_DETAIL.ROUTER_PATH });
      setPageParamState(params);
    } else if (
      breadcrumbMapping[pathname] ||
      pathname.startsWith(route.PRIVATE_ROUTE.REMINDER.PATH) ||
      pathname.startsWith(route.PRIVATE_ROUTE.COMMENT.PATH)
    ) {
      setPageParamState({});
    }
  };

  const handleAddTask = async () => {
    trackClickedAddTask();
    await handleRemoveParams();
    handleAddTaskButton();
  };

  const handleAddTaskButton = async () => {
    await dispatch(resetSidebarReducer());
    await dispatch(resetLinkTaskForNewTask());
    await dispatch(resetPlanMyday());
    dispatch(showTaskSidebarOnTop());
    const newTaskYdocRoom = generateYdocRoomId(id);
    dispatch(setShowTaskSidebar({ showTaskSidebar: true, isNewTask: true, tempYdocRoom: newTaskYdocRoom }));
  };

  /**
   * Removes params when add task is call
   * @author Shivam Mishra
   */
  const handleRemoveParams = () => {
    if (createTask) history.push(route.PRIVATE_ROUTE.TASKS.PATH);
  };

  useEffect(() => {
    if (views.length == 0 && !isTaskSidebarRoute) {
      (async () => {
        await dispatch(getUserView(auth?.user?.id));
      })();
    }
  }, []);

  useEffect(() => {
    if (deferHeaderSidebarLoading || (isTaskSidebarRoute && !task?.taskId) ) {
      return;
    }
    if (views.length == 0 && isTaskSidebarRoute) {
      (async () => {
        await dispatch(getUserView(auth?.user?.id));
      })();
    }
  }, [path, deferHeaderSidebarLoading, isTaskSidebarRoute, task?.taskId]);

  /**
   * handling the open/close of layout description
   * @params {void}
   * @returns {void}
   * @author Shivam
   */
  const handleShowDescription = () => {
    setShowDescription(!showDescription);
    dispatch(updatesIsCollabCentralOpened(!showDescription));
    handleCloseSidebar(dispatch, { isNewTask: false });
  };

  /**
   * Handles opening form filler from CollabCentral
   * @param {Object} item - The workflow item containing form details
   */
  const handleOpenFormFiller = async (item) => {
    try {
      setLoadingForm(true);

      // Close CollabCentral first
      setShowDescription(false);
      dispatch(updatesIsCollabCentralOpened(false));

      // Fetch form data
      const response = await getWorkflowFormById({
        id: item.Id,
      });

      if (response) {
        setFormData(response);
        setShowFormFiller(true);
      } else {
        throw new Error("No form data received");
      }
    } catch (error) {
      console.error("Error fetching form data:", error);
    } finally {
      setLoadingForm(false);
    }
  };

  /**
   * Handles form submission using the form submission hook
   * @param {Object} formResponses - The form response data
   */
  const handleFormSubmit = async (formResponses, getCalculationValue) => {
    try {
      await submitFormWithFiles({
        formData,
        formResponses,
        taskId: undefined, // No specific task ID for workflow forms
        getAttachmentObject,
        onSuccess: (response) => {
          // Close the form filler after successful submission
          setShowFormFiller(false);
        },
        onError: (error) => {
          console.error("Form submission error:", error);
        },
        getCalculationValue,
        formTab: FORM_TABS.SUBSECTIONS_OBJ,
      });
    } catch (error) {
      console.error("Error in form submission:", error);
      // Error handling is done in the hook
    }
  };

  /**
   * Closes the form filler modal
   */
  const handleCloseFormFiller = () => {
    setShowFormFiller(false);
    setFormData(null);
  };

  const handleRemindersHeaderClick = () => {
    handleCloseSidebar(dispatch, { isNewTask: false });
    dispatch(getNotificationsCount(user.id));
    history.push(route.PRIVATE_ROUTE.REMINDER.PATH);
  };

  const handleApprovalsHeaderClick = async () => {
    handleCloseSidebar(dispatch, { isNewTask: false });
    dispatch(getNotificationsCount(user.id));
    await dispatch(updateCurrUser({ lastSelectedBoard: label.GRID }));
    dispatch(setIsApprovalFilterSelected(true));
    const pendingApprovalsFilter = teamSavedFilters?.find((filter) => filter.label === label.PENDING_APPROVALS);
    dispatch(setLastFilterId(pendingApprovalsFilter?.value));
    history.push(route.PRIVATE_ROUTE.TASKS.PATH);
  };

  const handleOrganisationClick = async () => {
    const newShowOrganization = !showOrganization;
    await dispatch(updateCurrUser({ organisationPopUpShow: newShowOrganization }));
    setShowOragnization(newShowOrganization);
  };
  /**
   * handling the open/close of notification dropdown and clears notification count
   * @returns {void}
   */
  const handleNotificationButtonClick = () => {
    if (!notifications.showNotification) dispatch(setNotificationCount(number.ZERO));
    dispatch(setShowNotifications(!notifications.showNotification));
    dispatch(setIsApprovalFilterSelected(false));
  };

  const handleProject = async () => {
    history.push(`${route.PRIVATE_ROUTE.LANDING_PAGE.PATH}`);
  };

  /**
   * Handles click on project in breadcrumb
   * @author Sejal
   */
  const handleProjectClick = async () => {
    if (projectId == auth.user.myProjectId) {
      history.push(`${route.PRIVATE_ROUTE.USER_PROFILE_SETTING.PATH}`);
      return;
    }
    if (!projectId) {
      handleProject();
      return;
    }
    if (!projectClick) {
      return;
    }
    await dispatch(updateCurrUser({ organisationPopUpShow: false }));
    setShowOragnization(false);
    setShowProjectPopup(true);
    setShowQueuePopup(false);
    if (isPlanMyDayActive) {
      dispatch(resetSidebarReducer());
      dispatch(resetPlanMyday());
      return;
    }
    if (breadcrumbMapping[path] || isBoardOnlyBreadcrumbRoute) {
      history.push(`${route.PRIVATE_ROUTE.LANDING_PAGE.PATH}`);
      dispatch(updateCurrUser({ lastSelectedBoard: label.GRID }));
      return;
    }
  };
  let projectClick = !isPlanMyDayActive && (lastSelectedBoard !== label.GRID || projectId);

  const handleWorkflowClick = async () => {
    const isMyProject = projectId == auth.user.myProjectId;
    if (isMyProject) {
      history.push(`${route.PRIVATE_ROUTE.USER_PROFILE_SETTING.PATH}?IsWorkflow=true`);
    } else {
      history.push(`${route.PRIVATE_ROUTE.TEAM_SETTING.PATH}/${projectId}?IsWorkflow=true`);
    }
  };

  /**
   * Handles click on Automation in breadcrumb to navigate to automations tab
   * @author Muskan Thakur
   */
  const handleAutomationClick = async () => {
    if (!projectId || projectId == auth.user.myProjectId) {
      history.push(`${route.PRIVATE_ROUTE.USER_PROFILE_SETTING.PATH}?IsAutomation=1`);
    } else {
      history.push(`${route.PRIVATE_ROUTE.TEAM_SETTING.PATH}/${projectId}?IsAutomation=1`);
    }
  };
  /**
   * Handles click on queue in breadcrumb
   * @author Sejal
   */
  const handleQueue = async () => {
    await dispatch(updateCurrUser({ organisationPopUpShow: false }));
    setShowOragnization(false);
    setShowProjectPopup(false);
    setShowQueuePopup(true);
  };

  /**
   * Navigates to the tasks route and updates the current user's last selected board.
   * @author Bhavana
   */
  const handleWorkflow = () => {
    const isMyProject = projectId == auth.user.myProjectId;
    const basePath = route.PRIVATE_ROUTE.TASKS.PATH;
    const targetPath = isMyProject ? basePath : `${basePath}/${projectId}/${pageParamState?.projectName}`;
    history?.push(targetPath);
    dispatch(updateCurrUser({ lastSelectedBoard: label.GRID }));
  };
  /***
   * Toggles the showReminderPopup
   * @author Sarthak
   */
  const handleAddReminder = () => {
    setShowReminderPopup(!showReminderPopup);
  };

  const itemsHomePage = [
    {
      text: (
        <span>
          {" "}
          <span className='mr-1'>{icon.BELL}</span>
          {label.ADD_REM}
        </span>
      ),
      action: handleAddReminder,
    },
  ];

  const itemsReminderPage = [
    {
      text: (
        <>
          <span>
            <span className='mr-2'>{icon.ADD_TASK}</span>
            {label.ADD_TASK}
          </span>
        </>
      ),
      action: handleAddTask,
    },
  ];

  const popupSettings = {
    popupClass: "custom-split-popup",
    anchorAlign: { vertical: "bottom", horizontal: "right" },
    popupAlign: { vertical: "top", horizontal: "right" },
  };

  const handleItemClick = (event) => {
    const { item } = event;
    if (item.action) {
      item.action();
    }
  };

  /**
   * handles the breadcrumbs based on user selection
   * @param {Object} event
   * @author Muskan Thakur
   */
  const handleBreadcrumbSelection = (event) => {
    if (path.includes("cms")) {
      history.push(projectId ? `${route.PRIVATE_ROUTE.CMS.PATH}/${projectId}/${project}` : route.PRIVATE_ROUTE.CMS.PATH);
    }
    if (!event.nativeEvent.keyCode) {
      const newItem = searchTreeItem(contentManagerData, { path: event.id });
      dispatch(setSelectedContentItem(newItem));
      dispatch(setContentManagerDataDetails(newItem));
    }

    if (event.nativeEvent.keyCode === number.THIRTEEN) {
      const newItem = searchTreeItem(contentManagerData, { path: event.id });
      dispatch(setSelectedContentItem(newItem));
      dispatch(setContentManagerDataDetails(newItem));
    }
  };

  const handleFavoriteClick = useCallback(async () => {
    const getViewId = () => {
      if (isCmsRoute) return number.FIVE;
      if (isEmailRoute) return number.FOUR;
      return views.find((view) => view.Label === lastSelectedBoard)?.Id || null;
    };

    const payload = {
      projectId: projectId ? Number(projectId) : null,
      queueId: pageParamState.queueId ? Number(pageParamState.queueId) : null,
      viewId: getViewId(),
      userId: user.id,
    };
    const response = await dispatch(updateUserFavorite(payload));
    if (response) {
      if (response.actionStatus === label.INSERTED_SUCCESS) {
        const currentBoard = isCmsRoute ? label.LIBRARY : isEmailRoute ? route.PRIVATE_ROUTE.EMAILS.ENTITY_NAME : lastSelectedBoard;
        const currentView = views.find((view) => view.Label === currentBoard);

        const newView = {
          Id: response.newFavId,
          ProjectId: projectId ? Number(projectId) : null,
          QueueId: pageParamState.queueId ? Number(pageParamState.queueId) : null,
          ViewId: currentView?.Id || null,
          Icon: currentView?.Icon || null,
          Label: currentBoard,
          QueueName: pageParamState.queueId ? pageParamState?.queueName : null,
          ProjectName: projectId ? allProjectsList?.find((i) => i.ProjectId == Number(projectId))?.ProjectName : null,
        };
        dispatch(setUserFav([newView, ...userFavViews]));
        getNotification(quote.ADDED_TO_FAV, notifyIcon.SUCCESS_ICON);
      } else {
        dispatch(setUserFav(userFavViews.filter((item) => item.Id !== response.existingID)));
        getNotification(quote.REMOVED_FROM_FAV, notifyIcon.SUCCESS_ICON);
      }
    }
  }, [isFavorite, favoriteItem, projectId, pageParamState.queueId, views, lastSelectedBoard, user.Id, allProjectsList]);

  /**
   * returns the view name for the last breadcrumb
   * @author Sarthak Arora
   * @returns jsx
   */
  const getViewName = () => {
    if (lastSelectedBoard === label.GRID) {
      if (pageParamState?.queueId && queueFilter) {
        return (
          <span>
            {icon.RIGHT_BREADCRUMB} {label.APPROVALS}
          </span>
        );
      } else if (approvalFilter && isTaskRoute && !isPlanMyDayActive && !pageParamState?.queueId)
        return (
          <span>
            {icon.RIGHT_BREADCRUMB} {label.APPROVALS}
          </span>
        );
      else if (isPlanMyDayActive)
        return (
          <span>
            {icon.RIGHT_BREADCRUMB} {label.PLAN_MY_DAY}
          </span>
        );
      else
        return (
          <span>
            {icon.RIGHT_BREADCRUMB} {label.GRID}
          </span>
        );
    }
    if (lastSelectedBoard === label.TEAM_CONNECT) {
      return (
        <span>
          {icon.RIGHT_BREADCRUMB} {getTeamConnectLabel()}
        </span>
      );
    }
    return lastSelectedBoard !== label.GRID ? (
      lastSelectedBoard === label.STREAM ? (
        <span>
          {icon.RIGHT_BREADCRUMB} {label.STREAMS}
        </span>
      ) : (
        <span>
          {icon.RIGHT_BREADCRUMB} {lastSelectedBoard}
        </span>
      )
    ) : null;
  };

  const breadcrumbMapping = {
    "/notification": label.NOTIFICATIONS,
    "/taskHistory": label.RECENT_TASKS,
    "/userDirectory": label.DIRECTORY,
    "/email": label.EMAIL,
  };

  /**
   * Admin route breadcrumb mapping
   * Maps admin route paths to their display names
   * @author Sejal
   */
  const adminBreadcrumbMapping = {
    [route.ADMIN_ROUTE.MANAGE_USERS.PATH]: route.ADMIN_ROUTE.MANAGE_USERS.PROPS.HEADER,
    [route.ADMIN_ROUTE.MANAGE_PROJECTS.PATH]: `Manage ${operationalTeamName} `,
    [route.ADMIN_ROUTE.USAGE_SUMMARY.PATH]: route.ADMIN_ROUTE.USAGE_SUMMARY.PROPS.HEADER,
    [route.ADMIN_ROUTE.MANAGE_UTILIZATION.PATH]: route.ADMIN_ROUTE.MANAGE_UTILIZATION.PROPS.HEADER,
    [route.ADMIN_ROUTE.ACTIVITY_LOG.PATH]: route.ADMIN_ROUTE.ACTIVITY_LOG.PROPS.HEADER,
  };

  const isAdminRoute = Object.keys(adminBreadcrumbMapping).some((adminPath) => path.startsWith(adminPath));
  const isManageOrganizationRoute = path.startsWith(route.ADMIN_ROUTE.MANAGE_ORGANIZATION.PATH);

  // Get active organization sidebar from Redux for breadcrumb sync
  const activeOrganizationSidebar = useSelector((state) => state.admin.activeOrganizationSidebar);

  /**
   * Gets the selected sidebar feature from Redux state
   * @author Sejal
   */
  const getSelectedSidebarFeature = () => {
    return activeOrganizationSidebar;
  };

  /**
   * Navigates to Admin (Manage Organization) page
   * @author Sejal
   */
  const handleAdminClick = () => {
    history.push(route.ADMIN_ROUTE.MANAGE_USERS.PATH);
  };

  /**
   * Navigates to Manage Organization page with AI Integrations selected
   * @author Sejal
   */
  const handleManageOrganizationClick = () => {
    dispatch(setActiveOrganizationSidebar(label.AI_INTEGRATIONS));
    history.push(route.ADMIN_ROUTE.MANAGE_ORGANIZATION.PATH);
  };

  /**
   * Returns the breadcrumb JSX for admin routes
   * @author Sejal
   */
  const getAdminBreadcrumbs = () => {
    const adminPageName = Object.entries(adminBreadcrumbMapping).find(([adminPath]) => path.startsWith(adminPath))?.[1];

    if (!adminPageName) return null;

    return (
      <>
        <span className='link-text cursor-pointer' onClick={handleAdminClick}>
          Admin
        </span>
        {icon.RIGHT_BREADCRUMB}
        <span className='cursor-text'>{adminPageName}</span>
      </>
    );
  };

  /**
   * Returns the breadcrumb JSX for Manage Organization route
   * Format: Admin > Manage Organization > [Feature Name]
   * @author Sejal
   */
  const getManageOrganizationBreadcrumbs = () => {
    const selectedFeature = getSelectedSidebarFeature();
    const displayFeatureName = FEATURE_DISPLAY_NAMES[selectedFeature] || selectedFeature;

    return (
      <>
        <span className='link-text cursor-pointer' onClick={handleAdminClick}>
          Admin
        </span>
        {icon.RIGHT_BREADCRUMB}
        <span className='link-text cursor-pointer' onClick={handleManageOrganizationClick}>
          {route.ADMIN_ROUTE.MANAGE_ORGANIZATION.PROPS.HEADER}
        </span>
        {icon.RIGHT_BREADCRUMB}
        <span className='cursor-text'>{displayFeatureName}</span>
      </>
    );
  };

  /**
   * returns the jsx for breadcrumb of common pages using breadcrumbMapping
   * @author Sarthak Arora
   */
  const getBreadCrumbsForCommonPage = () => {
    if (isBoardOnlyBreadcrumbRoute || !breadcrumbMapping[path]) return null;
    return (
      <span>
        {icon.RIGHT_BREADCRUMB} {breadcrumbMapping[path]}
      </span>
    );
  };

  const renderBoardOnlyBreadcrumb = () => (
    <span
      ref={projectClickRef}
      className='blue cursor-pointer'
      onClick={handleProject}>
      {project}
    </span>
  );

  return (
    <React.Fragment>
      <Tooltip anchorElement='target' position='bottom' parentTitle='true'>
        <header id='page-topbar' className='position-fixed top-0 right-0'>
          <div className='navbar-header d-flex justify-content-between align-items-center'>
            <div className='d-flex align-items-center'>
              <Tooltip anchorElement='target' position='bottom' parentTitle='true'>
                <div className='position-relative'>
                  <button
                    className='btn  header-height align-items-center collab-central d-flex justify-content-between cursor-pointer bg-transparent ml-3 pl-1'
                    id='side-panel-collab-central'
                    title='Open Apps'
                    data-popup-trigger='organization'
                    ref={layoutDescriptionRef}
                    onClick={handleOrganisationClick}>
                    <span className='brand-logo  overflow-hidden mr-1'>
                      {companyPictures?.small ? <img src={`${companyPictures?.small}`} alt='org' className='logo '></img> : icon.BUSINESS}
                    </span>

                    {user.companyName}
                    {!!auth.user.isStreamUpdate && !organisationPopUpShow && (
                      <span className='red-dot badge-red-dot position-absolute header-organisation-popup-reddot rounded-circle  ml-2'></span>
                    )}
                  </button>
                  {organisationPopUpShow && (
                    <OrganisationPopUp
                      anchor={layoutDescriptionRef}
                      setShowPopup={handleOrganisationClick}
                      showPopup={showOrganization}
                      projectId={pageParamState.projectId}
                      queueName={pageParamState.queueName}
                      project={project}
                      queueId={pageParamState.queueId}
                      handleShowDescription={handleShowDescription}
                    />
                  )}

                  {showDescription && (
                    <CollabCentralLayout
                      isOrganisationDesc={true}
                      anchor={layoutDescriptionRef}
                      setShowPopup={handleShowDescription}
                      classicMode={false}
                      hidePreview={true}
                      onOpenFormFiller={handleOpenFormFiller}
                    />
                  )}
                </div>
              </Tooltip>
              <div className='d-flex navbar-left align-items-center'></div>
              {isCmsRoute ? (
                <>
                  <BreadcrumbComponent
                    data={selectedContentManagerItem}
                    itemPath={selectedContentManagerItem?.path}
                    handleBreadcrumbSelection={handleBreadcrumbSelection}
                    handleFavoriteClick={handleFavoriteClick}
                  />
                </>
              ) : (
                isBreadcrumbRoute && (
                  <Tooltip anchorElement='target' position='bottom' parentTitle='true'>
                    <span className='header-breadcrumb cursor-default ml-3'>
                      {isManageOrganizationRoute ? (
                        getManageOrganizationBreadcrumbs()
                      ) : isAdminRoute ? (
                        getAdminBreadcrumbs()
                      ) : path.startsWith(`${route.PRIVATE_ROUTE.EMAILS.PATH}`) ? (
                        <>
                          {queueName && (
                            <>
                              {" "}
                              <span ref={queueClickRef} className={`link-text cursor-pointer`} onClick={handleQueue} title={queueName}>
                                {queueName ? truncateName(queueName, number.THIRTY) : ""}
                              </span>
                              {icon.RIGHT_BREADCRUMB}
                            </>
                          )}
                          <span ref={projectClickRef} className={`link-text cursor-pointer`} onClick={handleProjectClick}>
                            {project}
                          </span>
                          {icon.RIGHT_BREADCRUMB}
                          <span className='cursor-text'>{label.EMAILS}</span>
                        </>
                      ) : commonPagePath ? (
                        header
                      ) : path.startsWith(`${route.PRIVATE_ROUTE.TEAM_SETTING.PATH}`) ? (
                        <>
                          <>
                            {queueName && (
                              <>
                                <span ref={queueClickRef} className={`link-text cursor-pointer`} onClick={handleQueue} title={queueName}>
                                  {queueName ? truncateName(queueName, number.THIRTY) : ""}
                                </span>
                                {icon.RIGHT_BREADCRUMB}
                              </>
                            )}
                            {project && (
                              <>
                                <span ref={projectClickRef} className={`link-text cursor-pointer`} onClick={handleProjectClick} title={project}>
                                  {project ? truncateName(project, number.THIRTY) : ""}
                                </span>
                                {icon.RIGHT_BREADCRUMB}
                                <span className='cursor-text'>{teamLeftSelectedTab}</span>
                              </>
                            )}
                          </>
                        </>
                      ) : path.includes("automation") ? (
                        <AutomationBreadcrumb
                          queueName={queueName}
                          project={project}
                          automationId={pageParamState?.automationId}
                          selectedAutomation={selectedAutomation}
                          automations={automations}
                          onQueueClick={handleQueue}
                          onProjectClick={handleProjectClick}
                          onAutomationClick={handleAutomationClick}
                          queueClickRef={queueClickRef}
                          projectClickRef={projectClickRef}
                        />
                      ) : workflowId && projectId && projectId == auth.user.myProjectId ? (
                        <>
                          <span className={`link-text cursor-pointer`} onClick={handleWorkflow}>
                            {project}
                          </span>
                          {icon.RIGHT_BREADCRUMB}
                          <span className={`link-text cursor-pointer`} onClick={handleWorkflowClick}>
                            Workflow
                          </span>
                          {icon.RIGHT_BREADCRUMB}
                          <span className='cursor-text'>{label.WORKFLOW_DESIGNER}</span>
                        </>
                      ) :  path === `${route.PRIVATE_ROUTE.QUEUES.PATH}` ? (
                       null
                      ) : 
                      workflowId && projectId && projectId != auth.user.myProjectId ? (
                        <>
                          <span ref={queueClickRef} className={`link-text cursor-pointer`} onClick={handleQueue} title={queueName}>
                            {queueName ? truncateName(queueName, number.THIRTY) : ""}
                          </span>
                          {icon.RIGHT_BREADCRUMB}
                          <span ref={projectClickRef} className={`link-text cursor-pointer`} onClick={handleProjectClick}>
                            {project}
                          </span>
                          {icon.RIGHT_BREADCRUMB}
                          <span className={`link-text cursor-pointer`} onClick={handleWorkflowClick}>
                            Workflow
                          </span>
                          {icon.RIGHT_BREADCRUMB}
                          <span className='cursor-text'>{label.WORKFLOW_DESIGNER}</span>
                        </>
                      ) : isBoardOnlyBreadcrumbRoute ? (
                        renderBoardOnlyBreadcrumb()
                      ) : projectId ? (
                        <>
                          <span ref={queueClickRef} className={`link-text cursor-pointer`} onClick={handleQueue} title={queueName}>
                            {queueName ? truncateName(queueName, number.THIRTY) : ""}
                          </span>
                          {icon.RIGHT_BREADCRUMB}
                          <span ref={projectClickRef} className={`link-text cursor-pointer`} onClick={handleProjectClick}>
                            {project}
                          </span>
                          <span className={`cursor-pointer link-text`} onClick={handleProjectClick}></span>
                          {getViewName()}
                        </>
                      ) : pageParamState.queueId ? (
                        <>
                          <span ref={queueClickRef} className={`cursor-pointer`} onClick={handleQueue} title={pageParamState?.queueName}>
                            {pageParamState?.queueName ? truncateName(pageParamState?.queueName, number.THIRTY) : ""}
                          </span>
                          {getViewName()}{" "}
                        </>
                      ) : !isDirectory ? (
                        path.startsWith(`${route.PRIVATE_ROUTE.USER_PROFILE_SETTING.PATH}`) ? (
                          <>
                            <span ref={projectClickRef} className={`link-text cursor-pointer`} onClick={handleProjectClick} title={project}>
                              {project ? truncateName(project, number.THIRTY) : ""}
                            </span>
                            {icon.RIGHT_BREADCRUMB}
                            {path.includes("filters") ? (
                              <span className='cursor-text'>{"Views"}</span>
                            ) : path.includes("workflows") ? (
                              <span className='cursor-text'>{"Workflows"}</span>
                            ) : path.includes("forms") ? (
                              <span className='cursor-text'>{"Forms"}</span>
                            ) :  path.includes("teams") || getQueryParams("IsProject", location.search) ? (
                              <span>My {appendString(operationalTeamName, label.SMALL_S) || label.TEAMS}</span>
                            ) : (
                              <span>Overview</span>
                            )}
                          </>
                        ) : (
                          <span>
                            <span
                              ref={projectClickRef}
                              className={`${
                                path === route.PRIVATE_ROUTE.TASKS.PATH && lastSelectedBoard === label.GRID && !isPlanMyDayActive
                                  ? "cursor-pointer blue"
                                  : "blue cursor-pointer"
                              }`}
                              onClick={handleProject}>
                              {project}
                            </span>
                            {isTaskRoute ? getViewName() : getBreadCrumbsForCommonPage()}
                          </span>
                        )
                      ) : (
                        <span>{label.USER_DIRECTORY}</span>
                      )}
                    </span>
                  </Tooltip>
                )
              )}
            </div>
            <div className='d-flex align-items-center'>
              {isCmsRoute ? (
                <div ref={addButtonRef}>
                  <MultiUploadDropdown
                    handleAddTask={handleAddTask}
                    handleAddReminder={handleAddReminder}
                    popupSettings={popupSettings}
                    addButtonRef={addButtonRef}
                    projectId={+projectId || null}
                    projectName={projectNameState}
                  />
                  {showReminderPopup && (
                    <ReminderContextProvider>
                      <AddReminderPopup
                        showReminderPopup={showReminderPopup}
                        setShowReminderPopup={setShowReminderPopup}
                        popupAnchor={addButtonRef}
                      />
                    </ReminderContextProvider>
                  )}
                </div>
              ) : (
                <div ref={addButtonRef}>
                  <HeaderSplitButton
                    showReminderPopup={showReminderPopup}
                    setShowReminderPopup={setShowReminderPopup}
                    addButtonRef={addButtonRef}
                    projectId={projectId}
                  />
                </div>
              )}
              {/* OverallSearch component */}
              <div className='app-search' ref={overallSearchRef}>
                <OverallSearch anchor={overallSearchRef} popupClass='header-search' />
              </div>

              {showApprovalIcon && (
                <div className='dropdown position-relative header-approval-icon plan-my-day-header-icon ml-2 mr-2'>
                  <button
                    type='button'
                    id='header-approvals-icon'
                    className='btn header-item header-icon header-hover-btn'
                    title={label.APPROVALS}
                    onClick={handleApprovalsHeaderClick}>
                    {icon.APPROVAL_ICON}
                  </button>
                  {approvalCount > number.ZERO && (
                    <span className='red-dot badge-red-dot position-absolute rounded-circle' />
                  )}
                </div>
              )}
              <div className='dropdown position-relative header-reminder-icon plan-my-day-header-icon ml-2'>
                <button
                  type='button'
                  id='header-reminders-icon'
                  className='btn header-item header-icon header-hover-btn'
                  title={reminderCount > number.ZERO ? tooltip.REMINDER_DUE : label.REMINDERS}
                  onClick={handleRemindersHeaderClick}>
                  {icon.BELL_ICON}
                </button>
                {reminderCount > number.ZERO && (
                  <span className='red-dot badge-red-dot position-absolute rounded-circle' />
                )}
              </div>
             
              {/* BackForwardNavigation component */}
              <div className={`dropdown`}>
                {" "}
                <BackForwardNavigation />{" "}
              </div>
              {/* BadgeContainer for Notifications */}
              <div className='dropdown'>
                <BadgeContainer>
                  <div className='cursor-pointer' id='header-notification-box' onClick={handleNotificationButtonClick}>
                    <button
                      type='button'
                      id='button-header-notify-icon'
                      className='btn header-item header-icon header-hover-btn ml-1'
                      title={tooltip.NOTIFICATIONS}>
                      {icon.VOLUME2}
                    </button>
                    {/* Conditionally showing notification indicator */}
                    {notifications.notificationCount > number.ZERO && !notifications.showNotification && (
                      <span className='notification-newstream-indicator badge-red-dot rounded-circle position-absolute'></span>
                    )}
                  </div>
                </BadgeContainer>
                {/* Conditionally showing Notifications component */}
                {notifications.showNotification && <Notifications />}
              </div>
              {/* UserDropdown */}
              <div className='d-inline-block dropdown'>
                <div className='ml-3' ref={buttonRef} onClick={() => handleDropdownClick()}>
                  <button type='button' id='button-header-profile-icon' className='bg-transparent header-icon p-0'>
                    {/* Conditionally rendering user profile picture or default icon */}
                    {auth.user.PhotoLinks?.small ? (
                      <img
                        alt='Profile Pic'
                        className={`profile-picture rounded-circle object-fit-cover ${
                          auth.user?.availabilityStatus === "Away" ? "profile-picture-away" : ""
                        }`}
                        src={auth.user.PhotoLinks?.small}
                      />
                    ) : (
                      icon.ACCOUNT_CIRCLE
                    )}
                  </button>
                  <span className='cursor-pointer'>
                    <span
                      className={`header-profile-down-arrow position-absolute ${
                        auth.user?.availabilityStatus === label.AVAILABLE ? "arrow-available" : ""
                      }`}>
                      {icon.ARROW_DROPDOWN_ICON}
                    </span>
                    <span className='header-profile-down-arrow-whtie position-absolute'>{icon.ARROW_DROPDOWN_ICON}</span>
                  </span>
                </div>
                {/* Conditionally showing UserDropdown */}
                <div ref={profileRef}>
                  {openProfile && <UserDropdown openProfile={openProfile} buttonRef={buttonRef} toggleDropdown={handleDropdownClick} />}
                </div>
              </div>
            </div>
          </div>
          {/* Loader component */}
          {loading && <Loader />}
        </header>
      </Tooltip>
      {/* Notes component */}
      <Notes />
      {/* Project Details Popup */}
      {showProjectPopup && showPopup && (
        <ProjectDetailsPopup
          show={showProjectPopup}
          onClose={() => setShowProjectPopup(false)}
          projectId={pageParamState?.projectId}
          anchor={projectClickRef}
        />
      )}
      {/* Queue Details Popup */}
      {showQueuePopup && showPopup && (
        <QueueDetailsPopup show={showQueuePopup} onClose={() => setShowQueuePopup(false)} anchor={queueClickRef} queueId={queueIdParam} />
      )}

      {/* Form Filler Modal - Rendered at Header level to persist when CollabCentral closes */}
      {showFormFiller && formData && (
        <FormFiller
          isOpen={showFormFiller}
          onClose={handleCloseFormFiller}
          formData={formData}
          formTitle={formData?.title}
          formDescription={formData?.description}
          onSubmit={handleFormSubmit}
          formTab={FORM_TABS.SUBSECTIONS_OBJ}
        />
      )}
    </React.Fragment>
  );
};

export default MainHeader;
